import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";


export const GroceryAddToPantrySheet = ({ open, item, form, submitting, onOpenChange, onFormChange, onSubmit }) => {
  return (
    <Drawer open={open} onOpenChange={onOpenChange} shouldScaleBackground={false}>
      <DrawerContent className="rounded-t-[28px] border-stone-200 bg-white px-4 pb-6" data-testid="grocery-add-pantry-sheet">
        <DrawerHeader className="px-0 text-left">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-stone-500" data-testid="grocery-add-pantry-sheet-kicker">
            Pantry bevestigen
          </p>
          <DrawerTitle className="mt-2 text-lg text-stone-900" data-testid="grocery-add-pantry-sheet-title">
            Voeg {item?.ingredient_name || "dit item"} toe aan je inventory
          </DrawerTitle>
          <DrawerDescription className="mt-2 text-sm text-stone-600" data-testid="grocery-add-pantry-sheet-description">
            Vul alleen aan wat ontbreekt. De bestaande merge-regel blijft actief.
          </DrawerDescription>
        </DrawerHeader>

        <div className="grid gap-3 pb-3" data-testid="grocery-add-pantry-sheet-form">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="mb-1 block text-xs font-semibold uppercase tracking-[0.2em] text-stone-500" htmlFor="grocery-add-pantry-quantity-input">
                Hoeveelheid
              </label>
              <Input
                id="grocery-add-pantry-quantity-input"
                type="number"
                min="0.1"
                step="0.1"
                value={form.quantity}
                onChange={(event) => onFormChange("quantity", event.target.value)}
                className="h-12 rounded-2xl border-stone-200 bg-stone-50"
                data-testid="grocery-add-pantry-quantity-input"
              />
            </div>
            <div>
              <label className="mb-1 block text-xs font-semibold uppercase tracking-[0.2em] text-stone-500" htmlFor="grocery-add-pantry-unit-trigger">
                Eenheid
              </label>
              <Select value={form.unit} onValueChange={(value) => onFormChange("unit", value)}>
                <SelectTrigger id="grocery-add-pantry-unit-trigger" className="h-12 rounded-2xl border-stone-200 bg-stone-50" data-testid="grocery-add-pantry-unit-select">
                  <SelectValue placeholder="Kies eenheid" />
                </SelectTrigger>
                <SelectContent>
                  {["g", "ml", "pcs", "slice"].map((unit) => (
                    <SelectItem key={unit} value={unit} data-testid={`grocery-add-pantry-unit-option-${unit}`}>
                      {unit}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="mb-1 block text-xs font-semibold uppercase tracking-[0.2em] text-stone-500" htmlFor="grocery-add-pantry-location-trigger">
                Locatie
              </label>
              <Select value={form.location} onValueChange={(value) => onFormChange("location", value)}>
                <SelectTrigger id="grocery-add-pantry-location-trigger" className="h-12 rounded-2xl border-stone-200 bg-stone-50" data-testid="grocery-add-pantry-location-select">
                  <SelectValue placeholder="Kies locatie" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="pantry" data-testid="grocery-add-pantry-location-option-pantry">Pantry</SelectItem>
                  <SelectItem value="stock" data-testid="grocery-add-pantry-location-option-stock">Stock</SelectItem>
                  <SelectItem value="fridge" data-testid="grocery-add-pantry-location-option-fridge">Koelkast</SelectItem>
                  <SelectItem value="freezer" data-testid="grocery-add-pantry-location-option-freezer">Vriezer</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <label className="mb-1 block text-xs font-semibold uppercase tracking-[0.2em] text-stone-500" htmlFor="grocery-add-pantry-status-trigger">
                Status
              </label>
              <Select value={form.status} onValueChange={(value) => onFormChange("status", value)}>
                <SelectTrigger id="grocery-add-pantry-status-trigger" className="h-12 rounded-2xl border-stone-200 bg-stone-50" data-testid="grocery-add-pantry-status-select">
                  <SelectValue placeholder="Kies status" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="sealed" data-testid="grocery-add-pantry-status-option-sealed">Sealed</SelectItem>
                  <SelectItem value="opened" data-testid="grocery-add-pantry-status-option-opened">Opened</SelectItem>
                  <SelectItem value="fresh" data-testid="grocery-add-pantry-status-option-fresh">Fresh</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>

        <DrawerFooter className="px-0 pb-0">
          <Button className="h-12 rounded-full bg-emerald-700 text-white hover:bg-emerald-800" disabled={submitting} onClick={onSubmit} data-testid="grocery-add-pantry-confirm-button">
            Voeg toe aan pantry
          </Button>
          <Button variant="outline" className="h-12 rounded-full border-stone-200 bg-white" disabled={submitting} onClick={() => onOpenChange(false)} data-testid="grocery-add-pantry-cancel-button">
            Annuleren
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};